import { Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";

import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import { Alert } from "@material-ui/lab";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import "./style.css";
import appActions from "redux/actions/appActions";

export default function SquareContactDevisPro(props) {
  const useStyles = makeStyles({
    container: {
      height: "100%",
      width: "100%"
    },
    square: {
      minWidth: 190,
      height: 350,
      borderRadius: 8,
      border: "solid 3px #e3e3e3",
      backgroundColor: "#ffffff",
      marginLeft: 5
    },
    text: {
      fontFamily: "Work Sans",
      fontSize: 21,
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      textAlign: "center",
      color: "#4a4a49"
    },
    price: {
      fontFamily: "Work Sans",
      fontSize: 56,
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      textAlign: "center",
      color: "#e85211",
      margin: 0
    },
    month: {
      opacity: 0.8,
      fontFamily: "Work Sans",
      fontSize: 20,
      fontWeight: 300,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      textAlign: "center",
      color: "#4a4a49"
    },
    check: {
      fontFamily: "Work Sans",
      fontSize: 14,
      fontWeight: 600,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      textAlign: "center",
      marginTop: 40,
      height: 42,
      borderRadius: 8,
      backgroundColor: "#E85313",
      color: "#ffff"
    },
    alert: {
      width: "30%",
      minWidth: 80,
      height: 30,
      borderRadius: 15,
      marginTop: 19,
      backgroundColor: "#fff8f5",
      textAlign: "center"
    },
    link: {
      height: 16,
      opacity: 0.8,
      fontFamily: "Work Sans",
      fontSize: 14,
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#4a4a49",
      textDecoration: "underline",
      marginBottom: 25
    },
    textLink: {
      color: "#4a4a49",
      textDecoration: "underline"
    }
  });

  const classes = useStyles();

  const formReducer = useSelector(store => store.formReducer);
  const dispatch = useDispatch();

  const getDocumentByCategorie = (categorie, documents) => {
    const result = documents.filter(data => data.categorie === categorie);

    if (result.length > 0) {
      return result[0];
    }

    return undefined;
  };

  const returnGrid = documents => {
    if (documents && documents.length <= 2) {
      return 6;
    } else if (documents && documents.length <= 1) {
      return 12;
    } else if (documents && documents.length <= 3) {
      return 4;
    }
  };

  const getDocumentNode = (libelle, document) => {
    if (!document) return null;
    return (
      <Grid
        container
        key={libelle}
        item
        xs={returnGrid(props.tarif && props.tarif.documents)}
        sm={returnGrid(props.tarif && props.tarif.documents)}
        justify="center"
        className={classes.link}
      >
        <p style={{ textAlign: "center" }}>
          <a className={classes.textLink} href={document.url}>
            {libelle}
          </a>
        </p>
      </Grid>
    );
  };

  const isSelected = useMemo(() => formReducer?.contactDevisPro?.data, [
    formReducer
  ]);

  const onCLick = () => {
    dispatch(appActions.data_form(!isSelected, "contactDevisPro"));
  };

  return (
    <div className={classes.container} style={{ marginBottom: 80 }}>
      <Card
        className={classes.square}
        style={{ borderColor: isSelected && "#E85313" }}
      >
        <Grid container justify="center" alignItems="flex-start">
          <Grid item xs={12} sm={12}>
            <p className={classes.text}>Multi-risque professionnelle</p>
          </Grid>
          <Grid item xs={12} sm={12}>
            <p className={classes.month}>
              Ce devis ne pourra être établi qu’après étude de notre service de
              gestion.
              <br />
              Choisissez cette offre pour être recontacté directement.
            </p>
            <Grid
              container
              item
              xs={12}
              sm={12}
              alignItems="flex-start"
              justify="center"
            >
              <Button
                onClick={onCLick}
                variant="contained"
                className={classes.check}
              >
                Choisir
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Card>
      {props.tarif && Array.isArray(props.tarif.documents) && (
        <Grid container>
          {getDocumentNode(
            "Synthèse des garanties",
            getDocumentByCategorie("SYNTHESE_GARANTIE", props.tarif.documents)
          )}
          {getDocumentNode(
            "Conditions Générales",
            getDocumentByCategorie(
              "CONDITIONS_GENERALES",
              props.tarif.documents
            )
          )}
          {getDocumentNode(
            "Fiche Produit",
            getDocumentByCategorie("FICHE_PRODUIT", props.tarif.documents)
          )}
        </Grid>
      )}

      {props.tarif && props.tarif.montantMensuel !== 0 && (
        <Grid
          item
          xs={12}
          sm={12}
          style={{ textAlign: "-webkit-center", marginBottom: 50 }}
        >
          <Alert icon={false} className={classes.alert}>
            {props.tarif && props.tarif.montantAnnuel}€/an
          </Alert>
        </Grid>
      )}
    </div>
  );
}

SquareContactDevisPro.propTypes = {};
